// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Registrars',
  subtitle: 'Manage domain registration firms',
  newRegistrar: 'New Registrar',
  addRegistrar: 'Add Company',
  editRegistrar: 'Edit Company',
  registrarName: 'Company Name',
  website: 'Website',
  apiKey: 'API Key',
  apiSecret: 'API Secret Key',
  status: 'Status',
  actions: 'Actions',
  noRegistrars: 'No registrars yet',
  noRegistrarsDesc: 'Start by adding your first registrar.',
  registrarAdded: 'Registrar successfully added',
  registrarUpdated: 'Registrar successfully updated',
  registrarDeleted: 'Registrar successfully deleted',
  fetchError: 'Registrars could not be retrieved',
  addError: 'Registrar could not be added',
  updateError: 'Registrar could not be updated',
  deleteError: 'Registrar could not be deleted',
  confirmDelete: 'Are you sure you want to delete this registrar?',
  statusEnabled: 'Registrar enabled',
  statusDisabled: 'Registrar disabled',
  statusError: 'Registrar status could not be updated',
  apiStatus: 'API Status',
  apiActive: 'API Active',
  apiNone: 'No API'
};
